import ARTICLE_CONTENT_TYPE from 'Constants/articleType'

export default function getContentJumpUrl(
  gidStr: string,
  articleType?: number
) {
  if (!gidStr) {
    return ''
  }

  if (articleType === undefined) {
    return `/article/${gidStr}`
  }

  const jumpPrefix = ARTICLE_CONTENT_TYPE[articleType]?.jumpPrefix

  if (jumpPrefix) {
    return `${jumpPrefix}/${gidStr}`
  }

  return `/article/${gidStr}`
}
